export const nextScenario = currentScenario => dispatch => {
  dispatch({
    type: "NEXT_SCENARIO",
    payload: currentScenario + 1
  });
};
